import { Controller } from "@hotwired/stimulus"
import { motionLite, replayAnimation, viewTransitionsEnabled } from "../lib/motion"
import { wizardDirection } from "../lib/wizard_transition"
import { NativeBridge } from "../lib/native_bridge"

// Wizard header (UI::WizardHeaderComponent): after a step visit the body slides in from the direction of travel
// (View Transitions do it on the web; this class fallback covers native shells), focus lands on the step title,
// and a just-saved step shows its 已儲存 chip in place of the old per-step toast.
export default class extends Controller {
  static targets = ["heading", "saved"]
  static values = { saved: Boolean }

  connect() {
    this.offsetToasts()
    const dir = wizardDirection()
    if (!dir) return

    if (!viewTransitionsEnabled() && !motionLite()) {
      const body = document.querySelector("[data-wizard-body]")
      body?.classList.add(dir === "back" ? "wizard-step-in-back" : "wizard-step-in-forward")
    }

    if (this.hasHeadingTarget) this.headingTarget.focus({ preventScroll: true })

    if (dir === "forward" && this.savedValue && this.hasSavedTarget) {
      this.savedTarget.hidden = false
      replayAnimation(this.savedTarget, "wizard-saved--in")
      NativeBridge.Haptic.selection()
    }
  }

  disconnect() {
    this.resizeObserver?.disconnect()
    // A step-move morph swaps headers (connect/disconnect order not guaranteed): keep the offset while one remains.
    if (!document.querySelector("header.wizard-header")) document.documentElement.style.removeProperty("--toast-offset-top")
  }

  // Toasts start below the sticky header, so they never cover the back button or the stepper.
  offsetToasts() {
    const set = () => document.documentElement.style.setProperty("--toast-offset-top", `${this.element.offsetHeight}px`)
    set()
    this.resizeObserver = new ResizeObserver(set)
    this.resizeObserver.observe(this.element)
  }
}
